import React from 'react';
import { Icon } from 'antd';
/** @jsx jsx */
import { css, jsx } from '@emotion/core';
// import data
import {headerItems, headerLogo} from '../assets/constants/header';

const Header = () => {
	return (
		<div css={css`
			width: 100%;
			line-height: 60px;
			background-color: #001529;
			display: flex;
			flex-direction: row;
			flex-wrap: nowrap;
			justify-content: flex-end;
			a {
				color: #ddd;
				padding: 0 15px;
			}
			img {
				padding: 10px;
				@media (max-width: 620px) {
					display: none;
				}
			}
			box-shadow: 0 2px 8px #f0f1f2;
		`}
		>
		<div css={css`
			flex-grow: 1;
		`}>
			<img src={headerLogo} alt="iMetaLab"/>
		</div>
		{
			headerItems.map((item, index)=>{
				return(
					<div key={item.key}>
						<Icon 
							style={{color: '#ddd'}}
							theme="filled"
							type={item.iconType}/>
						<a href={item.value}
							target="_blank"
							rel="noopener noreferrer"
						>
							<span>{item.label}</span>
						</a>
					</div>
				)
			})
		}
		</div>
	);
}

export default Header;